

angular
.module('inkfinder')
.factory('CalculateAvailability', function CalculateAvailability(
  $q,
  ScheduleUtilFactory,
  Shop,
  moment,
  RESPONSE_MESSAGES
) {
  // Public methods
  CalculateAvailability.calculate = calculate;

  /**
  * @name calculate
  * @description Takes a list of schedule instances and appointments and returns
  * a set of start/end pairs corresponding to availability between appointments.
  * @param {unknown} schedules Unknown.
  * @param {unknown} appointments Unknown.
  * @return {unknown} results
  */
  function calculate(schedules, appointments) {
    let results = [];

    let scheduleTotal = schedules.length;
    if (!scheduleTotal) {
      return results;
    }

    schedules.sort(function(a, b) {
      return a.start - b.start;
    });
    appointments.sort(function(a, b) {
      return a.date - b.date;
    });

    let aCount;
    let sCount;
    aCount = sCount = 0;
    // let startTime;
    // startTime = currentTime = schedules[sCount].start;
    let currentTime;
    currentTime = schedules[sCount].start;
    let endTime = schedules[scheduleTotal - 1].end;
    let appointmentTotal = appointments.length;

    // Iterate until the end of the schedule has been reached.
    while (currentTime < endTime) {
      // Skip over any appointments before the current time.
      while (aCount < appointmentTotal && appointments[aCount].end <
      currentTime) {
        aCount++;
      }
      // If there are no more appointments or the next appointment starts after the current schedule object ends, create an available time block from now until the end of the schedule object.
      if (aCount >= appointmentTotal || appointments[aCount].date >=
      schedules[sCount].end) {
        let start = currentTime;
        let end;
        end = currentTime = schedules[sCount].end;
        results.push({start: start, end: end});
      } else { // There are more appointments overlapping the current one, create available time blocks as needed.
        // Iterate across all appointments which start before the schedule block ends
        while (aCount < appointmentTotal && appointments[aCount].date <
        schedules[sCount].end) {
          // If there is a gap between the current time and the next appointment, create an available time block from now until the next appointment starts.
          if (currentTime < appointments[aCount].date) {
            let start = currentTime;
            let end = appointments[aCount].date;
            results.push({start: start, end: end});
          }
          // Advance the time to the end of the next appointment and move on to the next appointment
          currentTime = appointments[aCount].end;
          aCount++;
        }
        // Given the previous while() loop, there should be no more appointments starting before the end of the current schedule block. If there is any free time before the end of the schedule block, create an available time block from now until the end of the schedule object.
        if (currentTime < schedules[sCount].end) {
          let start = currentTime;
          let end;
          end = currentTime = schedules[sCount].end;
          results.push({start: start, end: end});
        }
      }
      // Given the previous conditions, we should've added all available time blocks which overlap this schedule block. Move on to the next schedule block.
      sCount++;
      // If this isn't the last schedule block, advance the current time to the start of the next schedule block.
      if (sCount < schedules.length && currentTime < schedules[sCount].start) {
        currentTime = schedules[sCount].start;
      }
    }
    return results;
  }
  return CalculateAvailability;
});



// WEBPACK FOOTER //
// ./components/schedule/util/calculate-availability.service.js